import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/C1';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getInfoC1() {
    return get(`${url}/info`);
}

export function submitC1(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
